import { render, staticRenderFns } from "./OnboardFormModal.vue?vue&type=template&id=c3448a36&scoped=true"
import script from "./OnboardFormModal.vue?vue&type=script&lang=js"
export * from "./OnboardFormModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardFormModal.vue?vue&type=style&index=0&id=c3448a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3448a36",
  null
  
)

export default component.exports